import SuperBillModal from './SuperBillModal.js';

export default SuperBillModal;
